{
  "id": "campaign-050",
  "name": "Lazy Meadow",
  "seed": "campaign:50",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".z....RRRRRR",
    ".z....RRRRRR",
    ".z....______",
    ".zzzzzz.....",
    "....ccz.....",
    "...TccT.u..u",
    "....cc......",
    "ffffffffff..",
    "............",
    ".....x...#..",
    "............",
    "fffffffff..f",
    "............",
    "zzz.~.y..y..",
    "..z.y~.....x",
    "....~.......",
    "...........S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 4,
      "y": 12
    },
    {
      "kind": "rabbit",
      "x": 0,
      "y": 3
    },
    {
      "kind": "rabbit",
      "x": 7,
      "y": 9
    },
    {
      "kind": "rabbit",
      "x": 1,
      "y": 15
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 8,
      "y": 15
    },
    {
      "kind": "gas",
      "x": 2,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 3
    }
  ],
  "generatorVersion": 3,
  "level": 50,
  "biome": "farm",
  "par": {
    "reel": 5385,
    "push": 5200,
    "selfPropelled": 4764,
    "tractor": 4250,
    "zeroTurn": 3078,
    "fairway": 2816
  },
  "routeTries": {
    "par": {
      "reel": 24,
      "push": 6,
      "selfPropelled": 8,
      "tractor": 2,
      "zeroTurn": 4,
      "fairway": 18
    }
  }
}
